import { cn } from '@/lib/utils';

/**
 * Standard admin-page container: full-height secondary background with
 * responsive padding and a centered max-width column. Replaces the
 * `min-h-screen bg-secondary p-6 md:p-12` > `max-w-7xl mx-auto` block that was
 * copy-pasted across the admin pages.
 */
const PageShell = ({ children, className }) => (
  <div className="min-h-screen bg-secondary p-6 md:p-12">
    <div className={cn('max-w-7xl mx-auto', className)}>{children}</div>
  </div>
);

export default PageShell;
